import { twMerge } from 'tailwind-merge'

// Pre-initialize tailwind-merge before Vue hydration begins.
// tailwind-merge lazy-builds its internal config on the first call; without this
// that cost is paid mid-hydration, contributing to the Long Task.
twMerge('')

export default defineNuxtPlugin(() => {})
